import PDMPlpPromotionList from "@tw/product-discovery-merchandizing-cra/lib/plp/promotion-list/plp-promotion-list-master-nextjs";
import PageWrapper from "../wrappers/page-wrapper";

PDMPlpPromotionList.domainName = "product-discovery";
export default PageWrapper(PDMPlpPromotionList);